const threshold = 4;

Object.defineProperty(PointerEvent.prototype, 'pos', { get: function() {
	// TODO(kr): cache m maybe?
	const m = this.currentTarget.getScreenCTM().inverse();
	const p = new DOMPoint(this.clientX, this.clientY, 0, 1);
	return p.matrixTransform(m);
}});

document.addEventListener("pointerdown", (evDown) => {
	const el = findDraggable(evDown.target);
	if (!el) {
		return;
	}

	let alreadyFired = false;

	const onMove = (evMove) => {
		evMove.stopPropagation();
		if (alreadyFired || distance(evDown, evMove) < threshold) {
			return;
		}
		alreadyFired = true;
		el.releasePointerCapture(evDown.pointerId);
		el.dispatchEvent(new Event("dragstart"));
	};

	const rmListeners = () => {
		el.removeEventListener("pointermove", onMove);
		el.removeEventListener("pointerup", onUp);
		el.removeEventListener("pointercancel", onCancel);
		el.removeEventListener("lostpointercapture", onLost);
	};

	const onUp = (evUp) => {
		evUp.stopPropagation();
		rmListeners();
	};

	const onCancel = (evCancel) => {
		evCancel.stopPropagation();
		rmListeners();
	};

	const onLost = (evLost) => {
		evLost.stopPropagation();
		rmListeners();
	};

	el.setPointerCapture(evDown.pointerId);
	el.addEventListener("pointermove", onMove);
	el.addEventListener("pointerup", onUp);
	el.addEventListener("pointercancel", onCancel);
	el.addEventListener("lostpointercapture", onLost);

});

function distance(a, b) {
	const x = b.pageX - a.pageX;
	const y = b.pageY - a.pageY;
	return Math.sqrt(x*x + y*y);
}

function findDraggable(el) {
	if (!el || el === document) {
		return null;
	}
	if (el instanceof SVGElement && el.getAttribute("draggable") === "true") {
		return el;
	}
	return findDraggable(el.parentNode);
}
